var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CenterCenter',[_c('div',{staticClass:"main"},[_c('div',{staticClass:"numberError"},[_vm._v(" "+_vm._s(_vm.$t('notFoundPage.sad'))+" ")]),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.$t('notFoundPage.title'))+" "),_c('br'),_vm._v(_vm._s(_vm.$t('notFoundPage.number'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }